/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Test_SentInputs */

const cs_sms_test_sent = /** @type {(inputs: Sms_Test_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testovací SMS odeslána`)
};

const en_sms_test_sent = /** @type {(inputs: Sms_Test_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test SMS sent`)
};

/**
* | output |
* | --- |
* | "Test SMS sent" |
*
* @param {Sms_Test_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_test_sent = /** @type {((inputs?: Sms_Test_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Test_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_test_sent(inputs)
	return cs_sms_test_sent(inputs)
});